import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Form, AbstractControl } from "@angular/forms";
import { Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../service/auth-service/auth.service";
import { sweetAlert } from "../../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { EquipmentService } from "../equipment-service/equipment.service";
import { CorporateService } from "../../corporate-user/corporate-service/corporate-service";

@Component({
  selector: 'app-add-equipment',
  templateUrl: './add-equipment.component.html',
  styleUrls: ['./add-equipment.component.css']
})
export class AddEquipmentComponent implements OnInit {
  equipmentForm: UntypedFormGroup;
  submitted = false;
  equipmentId;
 
  constructor(
    public authService: AuthService,
    private equipmentService: EquipmentService,
    private activatedRoute: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private router: Router,
  ) { }

  ngOnInit() {
    this.activatedRoute.params
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((params) => {
      this.equipmentId = params["id"];
      if(this.equipmentId){
        this.getEquipmentById();
      }
    });

    this.equipmentForm = this.fb.group({
      title: ["", Validators.required],
      status: ['active', Validators.required],
      description: [""],
      isAddon:[false]
    });

  }

  getEquipmentById(){
    this.equipmentService.getEquipmentbyId(this.equipmentId)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.equipmentForm.patchValue(data)
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    );
  }
 

  saveEquipment() {
    this.submitted = true;
    if (this.equipmentForm.invalid) {
      return;
    }
      let payload = this.equipmentForm.value;
      this.equipmentService.saveEquipment(this.equipmentId,payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.router.navigateByUrl("fleet/equipment");
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }


  get form() {
    return this.equipmentForm.controls;
  }
  onChangeToggle(control: AbstractControl) {
    control.setValue(!control.value);
  }

  ngOnDestroy(): void {
  }
}
